import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { listTimeOff } from "../api/time-off";
import { useCanAny } from "../auth/use-can";

/**
 * How many time-off requests are waiting for a decision — the count the old
 * *Time off* tab carried, now on the sidebar's **HR → Requests** link (MS-D3),
 * so it is seen from anywhere rather than only from inside the Staff page.
 *
 * Read for whoever decides leave or sees everyone's, re-read on each navigation
 * (a decision made on Requests is reflected the moment you leave it), and null —
 * no badge — for anyone else or when the read fails.
 */
export function useWaitingRequests(): number | null {
  const canAny = useCanAny();
  const decides = canAny(["staff.timeoff.decide", "staff.leave.view.any", "hr.team.view"]);
  const { pathname } = useLocation();
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    if (!decides) {
      setCount(null);
      return;
    }
    const controller = new AbortController();
    listTimeOff("PENDING", controller.signal)
      .then((rows) => setCount(rows.length))
      .catch(() => {
        if (!controller.signal.aborted) setCount(null);
      });
    return () => controller.abort();
  }, [decides, pathname]);

  return count;
}
